import React from 'react'
import AppsIcon from '@material-ui/icons/Apps'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@material-ui/core'
import StyledIconWrapper from './Styled/StyledIconWrapper'

const AppsMenuItem = ({ isActive }: { isActive: boolean }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const inActiveColor = theme.palette.text.secondary
  return (
    <div>
      <StyledIconWrapper>
        <AppsIcon
          aria-hidden="true"
          style={{ verticalAlign: 'bottom', color: !isActive ? inActiveColor : 'inherit' }}
        />
      </StyledIconWrapper>
      {t('All roles')}
    </div>
  )
}

export default AppsMenuItem
